import app from "../app"; // eslint-disable-line

export default () => {
  /**
   * Data + elements
   */
  const scrollTriggerSections = document.querySelectorAll('[data-scroll-trigger]');
  const sectionsInView = [];

  /** Functions */
  const updateSectionsInView = () => {
    scrollTriggerSections.forEach((section) => {
      const rect = section.getBoundingClientRect();

      const inView = (rect.top <= window.innerHeight / 2 && rect.top >= 0)
        || (window.innerHeight - rect.bottom <= window.innerHeight / 2 && window.innerHeight - rect.bottom >= 0) // eslint-disable-line
        || (rect.top < 0 && rect.bottom > window.innerHeight);

      const index = sectionsInView.indexOf(section);

      if (inView && index === -1) {
        sectionsInView.push(section);
      } else if (!inView && index >= 0) {
        sectionsInView.splice(index, 1);
      }
    });
  };

  const updateBackground = (section) => {
    if (section && section.dataset.background === 'dark') {
      document.body.classList.remove('light');
      document.body.classList.add('dark');
    } else {
      document.body.classList.remove('dark');
      document.body.classList.add('light');
    }
  };

  const update = () => {
    updateSectionsInView();

    const current = sectionsInView[0];

    updateBackground(current);

    app.emit('scrollTrigger', {
      triggeredSection: current,
    });
  };

  const init = () => {
    if (scrollTriggerSections.length) {
      update();
      app.on('window:scroll', update);
    }
  };

  /**
   * Init
   */
  init();
};
